import { render, staticRenderFns } from "./m1_examRegMenu.vue?vue&type=template&id=2f01327b&"
import script from "./m1_examRegMenu.vue?vue&type=script&lang=js&"
export * from "./m1_examRegMenu.vue?vue&type=script&lang=js&"
import style0 from "./m1_examRegMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports